module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 2
// module chunks = 0